import { createIcon } from "@chakra-ui/react";
import { Au, Br, Ca, Gb, In, RoundedEu, Us } from "@airhelp/flags";
import type { FlagProps } from "./Flags.d";

// TODO | Since we use this icon only on pt-br/brasil page it will be removed soon

const Anac = createIcon({
  displayName: "Anac",
  viewBox: "0 0 50 34",
  path: (
    <>
      <rect x="1" y="1" width="48" height="32" fill="#1659BF" />
      <path
        d="M16.0981 24.7496C16.1048 24.7412 16.1084 24.7309 16.1084 24.7202C16.1084 24.7096 16.1048 24.6992 16.0981 24.6908C15.7414 24.1157 15.5161 23.4721 15.4377 22.8041C15.3592 22.136 15.4296 21.4593 15.6438 20.8203C16.4101 17.9762 19.021 15.084 22.2121 13.2022C24.9531 11.715 27.7951 10.4129 30.7182 9.30497C28.7798 7.73021 26.3373 6.86942 23.8159 6.87253C22.3958 6.87183 20.9895 7.14441 19.6773 7.67471C18.3651 8.205 17.1727 8.98261 16.1683 9.96312C15.1638 10.9436 14.367 12.1078 13.8234 13.3892C13.2798 14.6705 13 16.0439 13 17.4309C12.9959 20.1601 14.0773 22.7842 16.016 24.7496C16.0241 24.7571 16.0349 24.7613 16.0461 24.7613C16.0573 24.7613 16.0681 24.7571 16.0762 24.7496"
        fill="white"
      />
      <path
        d="M32.6778 11.3578C29.6399 12.5039 26.6863 13.8524 23.8378 15.3941C20.8601 17.0995 18.4189 19.7671 17.7183 22.3974C17.1052 24.6801 17.9372 26.4122 19.7216 27.2088C21.0276 27.7328 22.426 28.0016 23.8378 28C25.2579 28 26.6641 27.7267 27.9761 27.1958C29.288 26.6648 30.48 25.8866 31.4839 24.9056C32.4878 23.9246 33.284 22.76 33.8269 21.4784C34.3699 20.1968 34.649 18.8233 34.6483 17.4363C34.6523 15.2613 33.9637 13.1389 32.6778 11.3632"
        fill="white"
      />
      <path
        d="M38.9615 11.8978L37.095 8.69018L37.9434 8.31596C38.0768 8.27551 38.1946 8.19675 38.2815 8.08995C38.3684 7.98314 38.4203 7.85325 38.4306 7.7172C38.4229 7.63711 38.3861 7.56236 38.3268 7.50647C38.2676 7.45058 38.1898 7.41723 38.1076 7.41248C37.8919 7.3895 37.6737 7.41137 37.4672 7.47663C37.3851 7.47663 36.8268 7.7279 36.2137 7.97916L32.1578 6.01183C32.1173 5.99606 32.0723 5.99606 32.0319 6.01183L31.8622 6.04925C31.8549 6.04925 31.848 6.05206 31.8428 6.05707C31.8377 6.06209 31.8348 6.06889 31.8348 6.07597C31.8348 6.08306 31.8377 6.08986 31.8428 6.09488C31.848 6.09989 31.8549 6.10271 31.8622 6.10271L34.7413 8.07004L35.1464 8.42822L34.4348 8.71156C34.2933 8.76982 34.1561 8.8377 34.0243 8.91471L33.8382 8.38011C33.8328 8.36449 33.8241 8.35014 33.8127 8.33801C33.8013 8.32587 33.7874 8.31621 33.7719 8.30966C33.7564 8.30311 33.7397 8.29981 33.7228 8.29997C33.706 8.30013 33.6893 8.30376 33.674 8.31061L33.4277 8.41219C33.4085 8.41971 33.3918 8.43212 33.3793 8.44811C33.3668 8.4641 33.3589 8.48308 33.3565 8.50307L33.2361 9.13925L31.8731 8.60464C31.7938 8.57503 31.7061 8.57503 31.6268 8.60464L31.3805 8.69018C31.3746 8.69267 31.3696 8.69679 31.3661 8.70201C31.3626 8.70723 31.3608 8.71334 31.3608 8.71958C31.3608 8.72582 31.3626 8.73193 31.3661 8.73716C31.3696 8.74238 31.3746 8.74649 31.3805 8.74898L32.9679 9.73265L33.0773 9.90373L33.8929 11.1333C33.8981 11.139 33.9044 11.1436 33.9114 11.1467C33.9185 11.1498 33.9262 11.1514 33.934 11.1514C33.9417 11.1514 33.9494 11.1498 33.9565 11.1467C33.9636 11.1436 33.9699 11.139 33.975 11.1333L34.1556 10.9515C34.1838 10.9241 34.2037 10.8897 34.2134 10.852C34.223 10.8144 34.222 10.7748 34.2104 10.7377L33.9531 9.83422C34.3284 9.80523 34.6973 9.72236 35.0478 9.58831C35.1354 9.55623 35.5952 9.36912 36.0605 9.15528L36.4655 9.51881L38.8028 12.1277C38.8072 12.1343 38.8134 12.1397 38.8205 12.1435C38.8277 12.1472 38.8357 12.1492 38.8438 12.1492C38.8519 12.1492 38.86 12.1472 38.8671 12.1435C38.8743 12.1397 38.8804 12.1343 38.8849 12.1277L38.9834 12.0047C38.9942 11.9889 39 11.9703 39 11.9512C39 11.9322 38.9942 11.9136 38.9834 11.8978"
        fill="white"
      />
      <path
        d="M1 1V0H0V1H1ZM49 1H50V0H49V1ZM49 33V34H50V33H49ZM1 33H0V34H1V33ZM1 2H49V0H1V2ZM48 1V33H50V1H48ZM49 32H1V34H49V32ZM2 33V1H0V33H2Z"
        fill="#F3F6F9"
      />
    </>
  ),
});

const euFlag = {
  flag: RoundedEu,
  text: "eu_regulation",
};

export const DEFAULT_FLAGS: FlagProps[] = [
  euFlag,
  {
    flag: Br,
    text: "brazilian_regulations",
  },
];

export const FLAGS_GB: FlagProps[] = [
  {
    flag: Gb,
    text: "gb_regulation",
  },
  euFlag,
];

export const FLAGS_BRASIL: FlagProps[] = [
  {
    flag: Br,
    text: "brazilian_regulations_brasil",
  },
  {
    flag: Anac,
    text: "anac_regulation",
  },
];

export const MONTREAL_ANIMATED_FLAGS = [Ca, Us, Gb, Au, In];
export const GB_LANGUAGE_CODE = "en-gb";
export const BR_LANGUAGE_CODE = "pt-br";
